import { Box, Button, HStack, Switch } from "@chakra-ui/react";
import { TitleModalPainel } from "@/components/ModalPainel/TitlePainel";
import { useState, useEffect } from "react";
import ActiveSwitch from "@/modules/Portaria/components/ActiveSwitch";

interface Props {
  defaultValues?: { [x: string]: any };
  handleSave: () => void;
  isLoading?: boolean;
  title?: string;
  IsActive?: (active: boolean) => void;
  value: boolean;
}

export function Form({ isLoading = false, title, handleSave, value, ...props }: Props) {
  const [isActive, setIsActive] = useState(value);


  useEffect(() => {
    setIsActive(value);
  }, [value]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      borderRadius="8px"
      shadow="md"
      bg="#fff"
      gap={5}
    >
      <>
        <HStack justify="space-between" m={3}>
          <TitleModalPainel title={title} />
          <ActiveSwitch
            size="sm"
            isChecked={isActive}
            onChange={(checked: boolean) => {
              setIsActive(checked);
              props.IsActive?.(checked);
            }}

          />
        </HStack>
        <HStack w="96%" justify="flex-end" m={2}>
          <Button
            colorScheme="blue"
            onClick={() => {
              handleSave();
            }}
            isLoading={isLoading}
          >
            Confirmar
          </Button>
        </HStack>
      </>
    </Box>
  );
}
